import HeaderContent from "./layout/components/HeaderContent";
import React from "react";
import { Create, CreateProps } from "react-admin";
import styled from "styled-components";

interface CreateWrapperProps extends CreateProps {
  breadcrumb: {
    link: string;
    title: string;
    params?: string;
  }[];
  headerTitle: string;
  children: React.ReactElement;
  isHaveSchoolFilter?: boolean;
}

const StyledCreate = styled(Create)({
  "& .MuiCardContent-root": {
    padding: "24px 34px",
  },
});

const CreateWrapper: React.FC<CreateWrapperProps> = (props) => {
  const {
    breadcrumb,
    headerTitle,
    children,
    isHaveSchoolFilter,
    ...createProps
  } = props;

  return (
    <>
      <HeaderContent
        breadcrumb={breadcrumb}
        headerTitle={headerTitle}
        isNotHaveSchoolFilter={!isHaveSchoolFilter}
      />

      <StyledCreate {...createProps}>{children}</StyledCreate>
    </>
  );
};

export default CreateWrapper;
